let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fgKjC")).then(() => parcelRequire('1JPa1'));